module.exports = __webpack_public_path__ + "static/fonts/Gotham-Ultra2.b8d72cb.otf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Gotham-Ultra2.otf
// module id = zppt
// module chunks = 1